import { TextNode as LexicalTextNode } from 'lexical';

class TextNode extends LexicalTextNode {
  static getType() {
    return 'custom-text';
  }

  static clone(node) {
    return new TextNode(node.__text, node.__key);
  }

  static importJSON(serializedNode) {
    return super.importJSON(serializedNode);
  }

  static importDOM() {
    return super.importDOM();
  }

  exportJSON() {
    return {
      ...super.exportJSON(),
      type: this.getType(),
    };
  }

  exportDOM(editor) {
    const { element } = super.exportDOM(editor);

    /**
     * For a better compatibility with other text editors, Lexical wraps
     * `<strong>` with `<b>` and `<em>` with `<i>`. Here we are undo this,
     * exporting directly the `<strong>` or `<em>`.
     */
    if (element.nodeName === 'B' || element.nodeName === 'I') {
      const child = element.children[0];

      // Removes default styles of LexicalJS
      child.removeAttribute('style');

      return { element: child };
    }

    // Removes default styles of LexicalJS
    element.removeAttribute('style');

    return { element };
  }

  createDOM(config) {
    return super.createDOM(config);
  }

  isSimpleText() {
    return (
      (this.__type === 'text' || this.__type === 'custom-text') &&
      this.__mode === 0
    );
  }
}

export const $addTextNodeConfig = (nodes) => {
  nodes.push(TextNode);
  nodes.push({
    replace: LexicalTextNode,
    with: (node) => new TextNode(node.__text),
  });
};

export default TextNode;
